var $bSzeT$reactariautils = require("@react-aria/utils");
var $bSzeT$reactariagridlist = require("@react-aria/gridlist");
var $bSzeT$reactariainteractions = require("@react-aria/interactions");
var $bSzeT$reactariai18n = require("@react-aria/i18n");
var $bSzeT$react = require("react");
var $bSzeT$reactariaselection = require("@react-aria/selection");
var $bSzeT$reactarialabel = require("@react-aria/label");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
$parcel$export(module.exports, "useTag", () => $a442534c81d8ad16$export$3f568fff7dff2f03);
$parcel$export(module.exports, "useTagGroup", () => $09704b0efefe5140$export$4f8b5cda58b7e8ff);
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

const $09704b0efefe5140$export$653eddfc964b0f8a = new WeakMap();
function $09704b0efefe5140$export$4f8b5cda58b7e8ff(props, state, ref) {
  let {
    direction: direction
  } = (0, $bSzeT$reactariai18n.useLocale)();
  let keyboardDelegate = props.keyboardDelegate || new (0, $bSzeT$reactariaselection.ListKeyboardDelegate)({
    collection: state.collection,
    ref: ref,
    orientation: "horizontal",
    direction: direction,
    disabledKeys: state.disabledKeys
  });
  let {
    labelProps: labelProps,
    fieldProps: fieldProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  } = (0, $bSzeT$reactarialabel.useField)({
    ...props,
    labelElementType: "span"
  });
  let {
    gridProps: gridProps
  } = (0, $bSzeT$reactariagridlist.useGridList)({
    ...props,
    ...fieldProps,
    keyboardDelegate: keyboardDelegate,
    shouldFocusWrap: true
  }, state, ref);
  let [isFocusWithin, setFocusWithin] = (0, $bSzeT$react.useState)(false);
  let {
    focusWithinProps: focusWithinProps
  } = (0, $bSzeT$reactariainteractions.useFocusWithin)({
    onFocusWithinChange: setFocusWithin
  });
  let domProps = (0, $bSzeT$reactariautils.filterDOMProps)(props);
  // If the last tag is removed, focus the container.
  let prevCount = (0, $bSzeT$react.useRef)(state.collection.size);
  (0, $bSzeT$react.useEffect)(() => {
    if (prevCount.current > 0 && state.collection.size === 0 && isFocusWithin) ref.current.focus();
    prevCount.current = state.collection.size;
  }, [state.collection.size, isFocusWithin, ref]);
  $09704b0efefe5140$export$653eddfc964b0f8a.set(state, {
    onRemove: props.onRemove
  });
  return {
    gridProps: (0, $bSzeT$reactariautils.mergeProps)(gridProps, domProps, {
      role: state.collection.size ? "grid" : null,
      "aria-atomic": false,
      "aria-relevant": "additions",
      "aria-live": isFocusWithin ? "polite" : "off",
      ...focusWithinProps,
      ...fieldProps
    }),
    labelProps: labelProps,
    descriptionProps: descriptionProps,
    errorMessageProps: errorMessageProps
  };
}
var $b6a2538ff098a9ff$exports = {};
var $6a4ddf1abe55d42a$exports = {};
$6a4ddf1abe55d42a$exports = {
  "removeButtonLabel": "\u0625\u0632\u0627\u0644\u0629",
  "removeDescription": "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0645\u0641\u062A\u0627\u062D DELETE \u0644\u0625\u0632\u0627\u0644\u0629 \u0639\u0644\u0627\u0645\u0629."
};
var $1bdc82b10375b4a8$exports = {};
$1bdc82b10375b4a8$exports = {
  "removeButtonLabel": "\u041F\u0440\u0435\u043C\u0430\u0445\u0432\u0430\u043D\u0435",
  "removeDescription": "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Delete, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u043C\u0430\u0445\u043D\u0435\u0442\u0435 \u043C\u0430\u0440\u043A\u0435\u0440\u0430."
};
var $e3fdf009dfe14bbc$exports = {};
$e3fdf009dfe14bbc$exports = {
  "removeButtonLabel": "Odebrat",
  "removeDescription": "Stisknut\xEDm kl\xE1vesy Delete odeberete zna\u010Dku."
};
var $8e3a8efadaa261b3$exports = {};
$8e3a8efadaa261b3$exports = {
  "removeButtonLabel": "Fjern",
  "removeDescription": "Tryk p\xE5 Slet for at fjerne tag."
};
var $405462110cf9cc8d$exports = {};
$405462110cf9cc8d$exports = {
  "removeButtonLabel": "Entfernen",
  "removeDescription": "Auf \u201EL\xF6schen\u201C dr\xFCcken, um das Tag zu entfernen."
};
var $9ec4c01646bfc149$exports = {};
$9ec4c01646bfc149$exports = {
  "removeButtonLabel": "\u039A\u03B1\u03C4\u03AC\u03C1\u03B3\u03B7\u03C3\u03B7",
  "removeDescription": "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 \u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03BA\u03B1\u03C4\u03B1\u03C1\u03B3\u03AE\u03C3\u03B5\u03C4\u03B5 \u03C4\u03B7\u03BD \u03B5\u03C4\u03B9\u03BA\u03AD\u03C4\u03B1."
};
var $0b797b6d677cd5c7$exports = {};
$0b797b6d677cd5c7$exports = {
  "removeDescription": "Press Delete to remove tag.",
  "removeButtonLabel": "Remove"
};
var $bacdb4955d86e000$exports = {};
$bacdb4955d86e000$exports = {
  "removeButtonLabel": "Quitar",
  "removeDescription": "Pulse Eliminar para quitar la etiqueta."
};
var $28e6b3e2003cb89e$exports = {};
$28e6b3e2003cb89e$exports = {
  "removeButtonLabel": "Eemalda",
  "removeDescription": "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
var $080ec9a9a4197fc3$exports = {};
$080ec9a9a4197fc3$exports = {
  "removeButtonLabel": "Poista",
  "removeDescription": "Poista tunniste painamalla Poista-painiketta."
};
var $d186548cad5da12b$exports = {};
$d186548cad5da12b$exports = {
  "removeButtonLabel": "Supprimer",
  "removeDescription": "Appuyez sur Supprimer pour supprimer l\u2019\xE9tiquette."
};
var $58694cb16d86dce9$exports = {};
$58694cb16d86dce9$exports = {
  "removeButtonLabel": "\u05D4\u05E1\u05E8",
  "removeDescription": "\u05DC\u05D7\u05E5 \u05E2\u05DC \u05DE\u05D7\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05E1\u05D9\u05E8 \u05EA\u05D2."
};
var $3622620b71bc3eed$exports = {};
$3622620b71bc3eed$exports = {
  "removeButtonLabel": "Ukloni",
  "removeDescription": "Pritisnite Delete za uklanjanje oznake."
};
var $25f88eb7a72b76e1$exports = {};
$25f88eb7a72b76e1$exports = {
  "removeButtonLabel": "Elt\xE1vol\xEDt\xE1s",
  "removeDescription": "Nyomja meg a Delete billenty\u0171t a c\xEDmke elt\xE1vol\xEDt\xE1s\xE1hoz."
};
var $ac7f4b0e2cb68452$exports = {};
$ac7f4b0e2cb68452$exports = {
  "removeButtonLabel": "Rimuovi",
  "removeDescription": "Premi Elimina per rimuovere il tag."
};
var $eb1a168dda0e2196$exports = {};
$eb1a168dda0e2196$exports = {
  "removeButtonLabel": "\u524A\u9664",
  "removeDescription": "\u30BF\u30B0\u3092\u524A\u9664\u3059\u308B\u306B\u306F\u3001Delete \u30AD\u30FC\u3092\u62BC\u3057\u307E\u3059\u3002"
};
var $eee5df414cc6e698$exports = {};
$eee5df414cc6e698$exports = {
  "removeButtonLabel": "\uC81C\uAC70",
  "removeDescription": "\uD0DC\uADF8\uB97C \uC81C\uAC70\uD558\uB824\uBA74 Delete \uD0A4\uB97C \uB204\uB974\uC2ED\uC2DC\uC624."
};
var $89b3b12fbd9b247d$exports = {};
$89b3b12fbd9b247d$exports = {
  "removeButtonLabel": "Pa\u0161alinti",
  "removeDescription": "Nor\u0117dami pa\u0161alinti \u017Eym\u0105, paspauskite \u201EDelete\u201C klavi\u0161\u0105."
};
var $1919b5d1d79b472a$exports = {};
$1919b5d1d79b472a$exports = {
  "removeButtonLabel": "No\u0146emt",
  "removeDescription": "Nospiediet Delete [Dz\u0113st], lai no\u0146emtu tagu."
};
var $19c1a9b6c040fcbd$exports = {};
$19c1a9b6c040fcbd$exports = {
  "removeButtonLabel": "Fjern",
  "removeDescription": "Trykk p\xE5 Slett for \xE5 fjerne taggen."
};
var $be2ec555d5f5fd09$exports = {};
$be2ec555d5f5fd09$exports = {
  "removeButtonLabel": "Verwijderen",
  "removeDescription": "Druk op Verwijderen om de tag te verwijderen."
};
var $949a33b7200b0e13$exports = {};
$949a33b7200b0e13$exports = {
  "removeButtonLabel": "Usu\u0144",
  "removeDescription": "Naci\u015Bnij Usu\u0144, aby usun\u0105\u0107 znacznik."
};
var $ae5f6174df72ed0e$exports = {};
$ae5f6174df72ed0e$exports = {
  "removeButtonLabel": "Remover",
  "removeDescription": "Pressione Delete para remover a tag."
};
var $f93b2eb3a2267af4$exports = {};
$f93b2eb3a2267af4$exports = {
  "removeButtonLabel": "Eliminar",
  "removeDescription": "Prima Delete para eliminar a tag."
};
var $0986e262b15bfc91$exports = {};
$0986e262b15bfc91$exports = {
  "removeButtonLabel": "\xCEndep\u0103rta\u0163i",
  "removeDescription": "Ap\u0103sa\u021Bi pe Delete (\u0218tergere) pentru a elimina eticheta."
};
var $1fc455c3f981c785$exports = {};
$1fc455c3f981c785$exports = {
  "removeButtonLabel": "\u0423\u0434\u0430\u043B\u0438\u0442\u044C",
  "removeDescription": "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 DELETE, \u0447\u0442\u043E\u0431\u044B \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0442\u0435\u0433."
};
var $93e0f346215d9446$exports = {};
$93e0f346215d9446$exports = {
  "removeButtonLabel": "Odstr\xE1ni\u0165",
  "removeDescription": "Ak chcete odstr\xE1ni\u0165 zna\u010Dku, stla\u010Dte kl\xE1ves Delete."
};
var $fef8a51090f12761$exports = {};
$fef8a51090f12761$exports = {
  "removeButtonLabel": "Odstrani",
  "removeDescription": "Pritisnite Delete, da odstranite oznako."
};
var $04502b7a450fc878$exports = {};
$04502b7a450fc878$exports = {
  "removeButtonLabel": "Ukloni",
  "removeDescription": "Pritisnite Obri\u0161i da biste uklonili oznaku."
};
var $95460d4e4c3e3778$exports = {};
$95460d4e4c3e3778$exports = {
  "removeButtonLabel": "Ta bort",
  "removeDescription": "Tryck p\xE5 Radera f\xF6r att ta bort taggen."
};
var $818e5758c72a695c$exports = {};
$818e5758c72a695c$exports = {
  "removeButtonLabel": "Kald\u0131r",
  "removeDescription": "Etiketi kald\u0131rmak i\xE7in Sil tu\u015Funa bas\u0131n."
};
var $5c17d07165fb1742$exports = {};
$5c17d07165fb1742$exports = {
  "removeButtonLabel": "\u0412\u0438\u043B\u0443\u0447\u0438\u0442\u0438",
  "removeDescription": "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C Delete, \u0449\u043E\u0431 \u0432\u0438\u043B\u0443\u0447\u0438\u0442\u0438 \u0442\u0435\u0433."
};
var $c6666cc31aa025e0$exports = {};
$c6666cc31aa025e0$exports = {
  "removeButtonLabel": "\u5220\u9664",
  "removeDescription": "\u6309\u4E0B\u201C\u5220\u9664\u201D\u4EE5\u5220\u9664\u6807\u8BB0\u3002"
};
var $a34b8398aee73e0f$exports = {};
$a34b8398aee73e0f$exports = {
  "removeButtonLabel": "\u79FB\u9664",
  "removeDescription": "\u6309 Delete \u9375\u4EE5\u79FB\u9664\u6A19\u8A18\u3002"
};
$b6a2538ff098a9ff$exports = {
  "ar-AE": $6a4ddf1abe55d42a$exports,
  "bg-BG": $1bdc82b10375b4a8$exports,
  "cs-CZ": $e3fdf009dfe14bbc$exports,
  "da-DK": $8e3a8efadaa261b3$exports,
  "de-DE": $405462110cf9cc8d$exports,
  "el-GR": $9ec4c01646bfc149$exports,
  "en-US": $0b797b6d677cd5c7$exports,
  "es-ES": $bacdb4955d86e000$exports,
  "et-EE": $28e6b3e2003cb89e$exports,
  "fi-FI": $080ec9a9a4197fc3$exports,
  "fr-FR": $d186548cad5da12b$exports,
  "he-IL": $58694cb16d86dce9$exports,
  "hr-HR": $3622620b71bc3eed$exports,
  "hu-HU": $25f88eb7a72b76e1$exports,
  "it-IT": $ac7f4b0e2cb68452$exports,
  "ja-JP": $eb1a168dda0e2196$exports,
  "ko-KR": $eee5df414cc6e698$exports,
  "lt-LT": $89b3b12fbd9b247d$exports,
  "lv-LV": $1919b5d1d79b472a$exports,
  "nb-NO": $19c1a9b6c040fcbd$exports,
  "nl-NL": $be2ec555d5f5fd09$exports,
  "pl-PL": $949a33b7200b0e13$exports,
  "pt-BR": $ae5f6174df72ed0e$exports,
  "pt-PT": $f93b2eb3a2267af4$exports,
  "ro-RO": $0986e262b15bfc91$exports,
  "ru-RU": $1fc455c3f981c785$exports,
  "sk-SK": $93e0f346215d9446$exports,
  "sl-SI": $fef8a51090f12761$exports,
  "sr-SP": $04502b7a450fc878$exports,
  "sv-SE": $95460d4e4c3e3778$exports,
  "tr-TR": $818e5758c72a695c$exports,
  "uk-UA": $5c17d07165fb1742$exports,
  "zh-CN": $c6666cc31aa025e0$exports,
  "zh-TW": $a34b8398aee73e0f$exports
};
function $a442534c81d8ad16$export$3f568fff7dff2f03(props, state, ref) {
  let {
    item: item
  } = props;
  let stringFormatter = (0, $bSzeT$reactariai18n.useLocalizedStringFormatter)((0, /*@__PURE__*/$parcel$interopDefault($b6a2538ff098a9ff$exports)));
  let buttonId = (0, $bSzeT$reactariautils.useId)();
  let {
    onRemove: onRemove
  } = (0, $09704b0efefe5140$export$653eddfc964b0f8a).get(state) || {};
  let {
    rowProps: rowProps,
    gridCellProps: gridCellProps,
    ...states
  } = (0, $bSzeT$reactariagridlist.useGridListItem)({
    node: item
  }, state, ref);
  // We want the group to handle keyboard navigation between tags.
  delete rowProps.onKeyDownCapture;
  delete states.descriptionProps;
  let onKeyDown = e => {
    if (e.key === "Delete" || e.key === "Backspace") {
      e.preventDefault();
      if (state.selectionManager.isSelected(item.key)) onRemove(new Set(state.selectionManager.selectedKeys));else onRemove(new Set([item.key]));
    }
  };
  let modality = (0, $bSzeT$reactariainteractions.useInteractionModality)();
  if (modality === "virtual" && typeof window !== "undefined" && "ontouchstart" in window) modality = "touch";
  let description = onRemove && (modality === "keyboard" || modality === "virtual") ? stringFormatter.format("removeDescription") : "";
  let descProps = (0, $bSzeT$reactariautils.useDescription)(description);
  let isFocused = item.key === state.selectionManager.focusedKey;
  // @ts-ignore - data attributes are ok but TS doesn't know about them.
  let domProps = (0, $bSzeT$reactariautils.filterDOMProps)(props);
  return {
    removeButtonProps: {
      "aria-label": stringFormatter.format("removeButtonLabel"),
      "aria-labelledby": "".concat(buttonId, " ").concat(rowProps.id),
      id: buttonId,
      onPress: () => onRemove ? onRemove(new Set([item.key])) : null,
      excludeFromTabOrder: true
    },
    rowProps: (0, $bSzeT$reactariautils.mergeProps)(rowProps, domProps, {
      tabIndex: isFocused || state.selectionManager.focusedKey == null ? 0 : -1,
      onKeyDown: onRemove ? onKeyDown : undefined,
      "aria-describedby": descProps["aria-describedby"]
    }),
    gridCellProps: (0, $bSzeT$reactariautils.mergeProps)(gridCellProps, {
      "aria-errormessage": props["aria-errormessage"],
      "aria-label": props["aria-label"]
    }),
    ...states,
    allowsRemoving: !!onRemove
  };
}